export enum EDebounceTime {
    DEFAULT = 500
}
